export default {
  PAID: { title: "Оплачений", value: 0, color: "green" },
  PARTIALLY_PAID: { title: "Частково оплачений", value: 1, color: "orange" },
  UNPAID: { title: "Неоплачений", value: 2, color: "red" },
};